import React, { useContext, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';
import showhide from "../../../../../Assets/ShowHide.svg";
import { updateCustomCollection } from '../../../../../lib/utils/apiCalls';
import { toast } from 'react-toastify';
import { closeModal, fetchCustomCollections } from '../../../../../Features/collectionsSlice';
import { CustomCollectionContext } from '../../../../../Context/Collections/CustomCollectionContext';
import { showToast } from '../../../../../Components/Toaster/Toaster';

function HideConfirmation() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const handleCancelClick = () => {
        dispatch(closeModal());
    }

    const { selectedCustomCollections, setSelectedCustomCollections } = useContext(CustomCollectionContext);

    const handleHideClick = async () => {
        if (selectedCustomCollections.length > 0) {
            dispatch(closeModal());

            const hidePromises = selectedCustomCollections.map(item => updateCustomCollection({
                isVisible: false
            }, item));

            const hideAllPromise = Promise.all(hidePromises);

            toast.promise(
                hideAllPromise,
                {
                    pending: {
                        render() {
                            return 'Hiding selected custom collections...';
                        },
                        className: 'toast-pending',
                    },
                    success: {
                        render() {
                            return 'Custom collections hidden successfully.';
                        },
                    },
                }
            );

            try {
                await hideAllPromise;
                dispatch(fetchCustomCollections());
                setSelectedCustomCollections([]);
            }
            catch (err) {
                showToast('Failed to hide some or all custom collections. Please try again.', 'error');
            }
        }
    }

    let productVisible = true;

    return (
        <div ref={wrapperRef} className="w-[38%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex items-center gap-[10px]">
                <div className="flex flex-col gap-3 w-[calc(100%-44px)]">
                    <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Are you sure want to hide?</h1>

                    <p className='font-normal text-[14px] leading-5 text-[#666666]'>Enabling this option will mark custom collections as hidden. You can reactivate a custom collection at any time.</p>
                </div>

                <button className={`outline-none flex items-center w-11 h-6 p-[2px] rounded-xl ${productVisible ? 'bg-[#4F46E5]' : 'bg-[#E5E7EB]'}`}>
                    <img className={`${productVisible ? 'ml-auto mr-[-2px]' : 'ml-[-2px]'} rounded-full`} src={showhide} alt="" />
                </button>
            </div>

            <div className="flex justify-end gap-3 font-medium font-inter">
                <button onClick={handleCancelClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                <button onClick={handleHideClick} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-primaryColor hover:bg-primaryAccent shadow-[0px_1px_2px_0px_#0000000D]'>Save changes</button>
            </div>
        </div>
    );
}

export default HideConfirmation;
